import { replaceProductSelection } from './replaceProductSelection';
import { setProductListingActiveTab } from './setProductListingActiveTab';
import resolveTreeLayerSelectionItem from './helpers/resolveTreeLayerSelectionItem';

export const syncTreeSelectionToProductLayer = ({
  productId,
  variantId,
  channelId,
  tab,
} = {}) => (dispatch, getState) => {
  const productsState = getState().products;
  const resolved = resolveTreeLayerSelectionItem({
    selection: productsState?.ui?.selection,
    productId,
    variantId,
    channelId,
    tab,
    productsState,
  });

  if (!resolved) return;

  dispatch(replaceProductSelection({
    item: resolved.item,
    source: 'tree',
    context: resolved.context,
  }));

  if (channelId && channelId !== 'master' && resolved.item.listingStatus) {
    dispatch(setProductListingActiveTab({
      productId,
      channelId,
      tab: resolved.item.listingStatus,
    }));
  }
};
